<template>
  <main-layout>
    <template #nav>
      <div class="flex flex-wrap items-center justify-between mx-auto">
        <h1 class="text-xl sm:text-2xl font-bold tracking-tight text-gray-900">Order Placed</h1>
        <router-link
          :to="{
            name: 'Basket',
            query: {
              token: Jwt,
            },
          }"
          class="relative inline-flex items-center p-1.5 text-sm font-medium text-center rounded-full border-2 border-secondary-600 focus:ring-0 focus:outline-none focus:ring-primary-600"
        >
          <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-secondary-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m5 11 4-7" /><path d="m19 11-4-7" /><path d="M2 11h20" /><path d="m3.5 11 1.6 7.4a2 2 0 0 0 2 1.6h9.8c.9 0 1.8-.7 2-1.6l1.7-7.4" /><path d="m9 11 1 9" /><path d="M4.5 15.5h15" /><path d="m15 11-1 9" /></svg>
          <span class="sr-only">Total basket items</span>
          <div class="absolute inline-flex items-center justify-center h-4 w-4 font-bold text-primary-600 bg-secondary-600 rounded-md -top-1 -right-2" style="font-size: 8px;">{{ TotalBasketItems }}</div>
        </router-link>
      </div>
    </template>
    <div class="p-6 bg-white border border-gray-200 rounded-md text-center">
      <h5 class="mb-2 text-2xl font-bold tracking-tight text-gray-900">Order Placed</h5>
      <p class="mb-3 font-normal text-gray-700">We have received your order.</p>
      <back-to-whats-app />
    </div>
  </main-layout>
</template>

<script setup>
import {
  computed,
} from 'vue';
import { useBasketStore } from '@/stores/basket';

import BackToWhatsApp from '@/components/shared/BackToWhatsApp.vue';
import MainLayout from '@/layouts/MainLayout.vue';
import { useAccountStore } from '@/stores/account';

const TotalBasketItems = computed(() => useBasketStore().TotalItems);
const Jwt = computed(() => useAccountStore().Jwt);

</script>
